import { cn } from "@/lib/utils"

type RanksBackgroundProps = React.HTMLAttributes<HTMLDivElement>
const RanksBackground = ({ className, ...otherProps }: RanksBackgroundProps) => {
  return (
    <div
      className={cn(
        "absolute top-1/2 left-1/2 z-[-1] flex h-56 w-56 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full transition-all",
        className,
      )}
      {...otherProps}></div>
  )
}

export { RanksBackground }
